import { z } from 'zod';
import { CohortEnumSchema } from '@eigtech/auth0-types';
/** Mark note for publication */
export const MarkNoteForPublicationBodyRequestSchema = z.object({
    publicationTargets: z.string().array(),
    publicationCohorts: CohortEnumSchema.array().optional()
});
export const MarkNoteForPublicationPathRequestSchema = z.object({
    noteId: z.string(),
});
export const MarkNoteForPublicationRequestSchema = MarkNoteForPublicationBodyRequestSchema.merge(MarkNoteForPublicationPathRequestSchema);
